import { FC } from 'react';
import { CheckboxIndeterminateIcon, CheckboxIndeterminateIconProps } from '../../../Checkbox';

export type CheckboxCardControlIndeterminateIconProps = CheckboxIndeterminateIconProps

export const CheckboxCardControlIndeterminateIcon: FC<CheckboxCardControlIndeterminateIconProps> = (props) => {
  return <CheckboxIndeterminateIcon {...props} />
}